<adapt-dialog class="add-people-dialog"
              [maxWidth]="850">
    <h3 adapt-dialog-title>Add {{ dialogTitleSuffix.toLowerCase() }}</h3>

    <ng-container adapt-dialog-content>
        <div class="card people-area">
            <div class="card-header">
                <h2>Set the people you wish to add to the organisation</h2>
                <button adaptButton="addLink"
                        class="ms-auto me-5"
                        (click)="addAnotherPerson()">Add another person</button>
            </div>
            <div class="card-body d-flex flex-column">
                <dx-data-grid [dataSource]="addPeopleGridData"
                              [showRowLines]="true"
                              [showBorders]="true"
                              [allowColumnResizing]="true"
                              (onCellPrepared)="onCellPrepared($event)"
                              (onInitNewRow)="onInitNewRow($event)"
                              (onToolbarPreparing)="customiseToolbar($event.toolbarOptions)"
                              [wordWrapEnabled]="true"
                              (paste)="handlePaste($event)"
                              (onInitialized)="onInitialised($event)">
                    <dxo-data-grid-paging [pageSize]="10"></dxo-data-grid-paging>
                    <dxo-data-grid-editing mode="cell"
                                           [allowDeleting]="true"
                                           [allowUpdating]="true"
                                           [useIcons]="true"
                                           [confirmDelete]="false"> </dxo-data-grid-editing>

                    <dxi-data-grid-column dataField="addedTime"
                                          dataType="date"
                                          [visible]="false"
                                          sortOrder="desc"> </dxi-data-grid-column>
                    <dxi-data-grid-column dataField="firstName"
                                          caption="First name"
                                          [width]="195"> </dxi-data-grid-column>
                    <dxi-data-grid-column dataField="lastName"
                                          caption="Last name"
                                          [width]="195"> </dxi-data-grid-column>
                    <dxi-data-grid-column dataField="email"
                                          [width]="285"> </dxi-data-grid-column>
                </dx-data-grid>
                <small class="mt-n3">
                    Note: values can be pasted {{ pasteCommand }} from an Excel spreadsheet or any comma-separated source.
                    <br />
                    Inviting active members of the organisation will not change their user type, role, or access level.</small>
            </div>
        </div>

        @if (!config?.connectionType) {
            <div class="card">
                <div class="card-header">
                    <h2>How are these people connected to your organisation</h2>
                </div>
                <div class="card-body">
                    <div class="alert alert-warning mt-2">
                        Employee are those people who are generally employed by your organisation. Depending on how you structure your
                        organisation these people may by full-time, part-time or even contractors. Employee's will be included in surveys,
                        cultural measurements, etc.
                        <br /><br />
                        Stakeholders are those people connected to your organisation in other ways - they might be external consultants,
                        customers, investors, potential employees, etc.
                    </div>
                    <div class="limited-width-area">
                        <adapt-select-connection-type [(connectionType)]="connectionType"
                                                      (connectionTypeChange)="connectionTypeChange()"
                                                      data-test="select-connection-type"></adapt-select-connection-type>
                    </div>
                </div>
            </div>
        }

        <div class="card">
            <div class="card-header">
                <h2>Set user type and access level for these people</h2>
            </div>
            <div class="card-body limited-width-area">
                <label>User type</label>
                <adapt-select-user-type [(userType)]="userType"
                                        [connectionType]="connectionType"
                                        (userTypeChange)="userTypeChange()"
                                        data-test="select-user-type"></adapt-select-user-type>

                @if (userType !== UserType.None) {
                    <div class="mt-2">
                        <label>Access level</label>
                        <adapt-select-access-level [userType]="userType"
                                                   [(accessLevel)]="selectedAccessLevel"
                                                   data-test="select-access-level"></adapt-select-access-level>
                    </div>
                }
            </div>
        </div>

        @if (userType !== UserType.None) {
            <div class="card">
                <div class="card-header">
                    <h2>Set whether they should be able to log into Lumia</h2>
                </div>
                <div class="card-body">
                    <dx-check-box [value]="activateAccounts"
                                  (valueChange)="activateAccounts = $any($event)"
                                  [disabled]="eulaUnaccepted$ | async"
                                  text="Allow these people to log in to Lumia"
                                  data-test="activate-accounts-checkbox"></dx-check-box>
                    @if (!activateAccounts) {
                        <div class="alert alert-warning mt-2"
                             role="alert">
                            Note: As the above option is unticked, these people will be visible inside Lumia but they will NOT be able to
                            log in.
                            @if (eulaUnaccepted$ | async) {
                                <br /><br />
                                <b>As the Customer License Agreement has not been accepted, no users are allowed to log into Lumia and
                                    therefore this option has been disabled.</b>
                            }
                            <br /><br />
                            At a later date you can allow them to log in to Lumia via the 'Manage People' page (accessible from the
                            configuration menu at the bottom left of the Lumia interface).
                        </div>
                    }
                </div>
            </div>
        }
    </ng-container>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   saveText="OK"
                                   [saveBlockingClick]="addAndSave"
                                   (cancelClick)="cancel()"> </adapt-standard-dialog-buttons>
</adapt-dialog>
